<template>
<div class="chapter">
<div class="inner_page">
<p class="p3"><span class="sz"> </span></p>
<p class="p3"><span class="sz"> </span></p>
<p class="p4"><span class="sz"><b>Adjusted Planck Units – Distance</b></span></p>
<p class="p3"><span class="sz"><b></b> </span></p>
<p class="p4"><span class="sz"><b>Old Meters</b></span></p>
<p class="p3"><span class="sz"> </span></p>
<div style="text-align:center"><img alt="Echoes-of-Earth-Diagram-Two" src="images/Echoes-of-Earth-Diagram-Two.png"/></div>
<p class="p3"><span class="sz"> </span></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section5.vue?21432c51